export const DEFAULT_COMPANY_CONFIG = {
	'name': 'Tak Man Nursing Centre Limited',
	'url': 'https://erp.takmannursing.com',
	'logo': '/assets/img/logo.png',
	'bg': '/assets/img/bg.jpg',
  'serial_no': 'SYS-05'
}